export default "__VITE_ASSET__BTKb9NXt__"